module.exports = __webpack_public_path__ + "img/undraw_Graduation_ktn0.359daf43.svg";